<template>
    <div
        class="tooltip-with-question-mark flex-al-i-c"
        :class="[{ absolute: absolute, relative: !absolute }, additionalClass]"
        :style="generalTooltipStyles"
    >
        <p
            :id="btnId"
            class="tooltip-icon flex-center"
            :class="{
                'tooltip-icon_blue': isTooltipBlue,
                'tooltip-icon_orange': isTooltipOrange,
                'tooltip-icon_white': isTooltipWhite,
                'tooltip-icon_no-styles': !defaultButtonStyles,
                'tooltip-icon_init-width': !defaultButtonWidth,
                ['tooltip-icon_width__' + buttonWidth]: buttonWidth
            }"
            @click="handleState"
            v-click-outside="hide"
        >
            <span v-if="!isButtonSlotExists">?</span>

            <slot v-if="isButtonSlotExists" name="button"></slot>
        </p>

        <div v-if="showTooltip && blurBackground" class="blurred" @click="close"></div>
        <template v-if="internalContent">
            <TooltipWithQuestionMarkContent
                v-if="showTooltip"
                :windowSize="windowSize"
                :btnId="btnId"
                :positionClasses="positionClasses"
                :showCloseButton="showCloseButton"
                :blurBackground="blurBackground"
                :width="width"
                :tooltipTitle="tooltipTitle"
                :tooltipText="tooltipText"
                :tooltipList="tooltipList"
                :tooltipListHtml="tooltipListHtml"
                :listNameToTrack="listNameToTrack"
                :additionalClass="additionalClass"
                :additionalListClass="additionalListClass"
                @close="close"
            >
                <slot></slot>
            </TooltipWithQuestionMarkContent>
        </template>
        <!-- <portal v-else to="tooltip-with-question-mark-output">-->
        <portal v-else to="modals">
            <TooltipWithQuestionMarkContent
                v-if="showTooltip"
                :key="updateContent"
                class="tooltip-with-question-mark"
                :windowSize="windowSize"
                :btnId="btnId"
                :positionClasses="positionClasses"
                :showCloseButton="showCloseButton"
                :blurBackground="blurBackground"
                :width="width"
                :tooltipTitle="tooltipTitle"
                :tooltipText="tooltipText"
                :tooltipList="tooltipList"
                :tooltipListHtml="tooltipListHtml"
                :listNameToTrack="listNameToTrack"
                :additionalClass="additionalClass"
                :additionalListClass="additionalListClass"
                :internalContent="internalContent"
                :component-id="contentId"
                @close="close"
            >
                <slot></slot>
            </TooltipWithQuestionMarkContent>
        </portal>
    </div>
</template>

<script>
import ClickOutside from "vue-click-outside"
import TooltipWithQuestionMarkContent from "@components/Tooltips/TooltipWithQuestionMarkContent.vue"
import { v4 } from "uuid"

export default {
    name: "TooltipWithQuestionMark",
    components: { TooltipWithQuestionMarkContent },
    props: {
        isTooltipBlue: {
            type: Boolean,
            default: false
        },
        isTooltipOrange: {
            type: Boolean,
            default: false
        },
        isTooltipWhite: {
            type: Boolean,
            default: false
        },
        internalContent: {
            type: Boolean,
            default: true
        },
        tooltipText: [String],
        tooltipTitle: [String],
        tooltipList: [Array],
        tooltipListHtml: [Array],
        width: [Number],
        absolute: {
            type: Boolean,
            default: true
        },
        /**
         * @values "top-left", "top-center", "top-right", "center-left", "center-right", "bottom-right", "bottom-center", "bottom-left"
         **/
        positionClasses: {
            type: String,
            default: "bottom-right"
        },
        /**
         * Additional class to understand that tooltip is situated inside parent modal
         * that allow the parent listener continuing parent model be open (example: CreationDataModalContainer
         **/
        additionalClass: {
            type: String,
            default: null
        },
        additionalListClass: [String],
        listNameToTrack: {
            type: String,
            default: "name"
        },
        /**
         * @values "15", "20"
         **/
        buttonWidth: {
            type: Number,
            default: 0
        },
        stopPropagation: {
            type: Boolean,
            default: false
        },
        isButtonSlotExists: {
            type: Boolean,
            default: false
        },
        isContentSlotExists: {
            type: Boolean,
            default: false
        },
        defaultButtonStyles: {
            type: Boolean,
            default: true
        },
        defaultButtonWidth: {
            type: Boolean,
            default: true
        },
        display: String,
        blurBackground: {
            type: Boolean,
            default: false
        },
        // Moderate content window openness
        openContent: {
            type: Boolean,
            default: true
        },
        /**
         * @values "small", "regular", "large"
         **/
        windowSize: {
            type: String,
            default: "regular"
        },
        showCloseButton: {
            type: Boolean,
            default: true
        },
        checkInsideModal: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        showTooltip: false,
        componentId: null,
        btnId: null,
        updateContent: null,
        contentId: `tooltip-wrap-${v4()}`
    }),
    directives: { ClickOutside },
    computed: {
        generalTooltipStyles() {
            return {
                display: this.display && this.display
            }
        }
    },
    watch: {
        showTooltip(val) {
            this.$emit("handleTooltipState", val)
        }
    },
    created() {
        this.componentId = this._uid
        this.btnId = "tooltip-btn-id-" + this.componentId
    },
    methods: {
        handleState(event) {
            if (this.checkInsideModal) {
                if (this.showTooltip && !document.querySelector(`#${this.contentId}`)) {
                    this.close()
                }
                if (
                    sessionStorage.getItem("tooltipId") &&
                    document.querySelector(`#${sessionStorage.getItem("tooltipId")}`)
                ) {
                    document.querySelector(`#${sessionStorage.getItem("tooltipId")}`).remove()
                    sessionStorage.removeItem("tooltipId")
                }
                sessionStorage.setItem("tooltipId", this.contentId)
            } else if (sessionStorage.getItem("tooltipId")) {
                sessionStorage.removeItem("tooltipId")
            }

            // Handle button click
            this.$emit("handleClick", this.showTooltip)

            this.updateContent = Math.random()

            // Do not open window if not allowed
            if (!this.openContent) return

            if (this.stopPropagation) event.stopPropagation()
            this.showTooltip = !this.showTooltip
            this.$emit("getClick", this.showTooltip)
        },
        hide(event) {
            let test = event.target.closest(".tooltip-with-question-mark")
            if (!test || test !== this.$el) this.close()
        },
        openFromOutside() {
            setTimeout(() => (this.showTooltip = true), 0)
        },
        close() {
            this.showTooltip = false
        }
    }
}
</script>

<style lang="sass">
.blurred
    z-index: 300
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100%
    background: rgba(255, 255, 255, 0.5)
    backdrop-filter: blur(3px)
//background: rgba(242, 242, 255, 0.7)
//background: rgba(242, 242, 255, 0.2)
//filter: blur(4px)

.show-content-under
    z-index: 1000
</style>
